import React, { useEffect } from 'react';
import './App.css';
import Chart from './components/charts/Chart';
import TimelineChart from './components/charts/TimelineChart';
import { Footer } from './components/Footer';
import ReactGA from 'react-ga'; 
import GenderChart from './components/charts/GenderChart';
import DeathsTimelineChart from './components/charts/DeathsTimelineChart';
import LiveTimelineChart from './components/charts/LiveTimelineChart';
import moment from 'moment'; 
import Header from 'components/Header';
import MapSection from 'components/MapSection';

export const App = () => { 

  
  useEffect(() => {
    ReactGA.initialize('UA-175547717-1');
    ReactGA.pageview(window.location.pathname + window.location.search); 
  }, []);

  return (
    <div className="App">
        <Header />
      <div className="grid-2">
        <Chart/> 
        <GenderChart />
      </div>
      <div className="grid-2">
        <TimelineChart />
        <DeathsTimelineChart />
      </div>
      <div className="container">
        <LiveTimelineChart />
      </div>
        <MapSection/>
        <Footer />
    </div>
  );
};

export default App;
